<nb-card>
  <nb-card-header>
    <div class="menu-buttons">
      <button
        *ngIf="user.printReceiptA4"
        [ngClass]="menu == 'a4' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'a4' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('a4')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>A4</span>
      </button>

      <button
        *ngIf="user.printReceiptA4"
        [ngClass]="menu == 'a4-stock' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'a4-stock' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('a4-stock')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>A4 - {{ "warehouse.issueStock" | translate }}</span>
      </button>

      <button
        *ngIf="user.printReceiptPos"
        [ngClass]="menu == 'pos' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'pos' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltip="POS"
        nbTooltipPlacement="bottom"
        (click)="selectMenu('pos')"
      >
        <nb-icon class="button-icon" icon="file-text-outline"></nb-icon>
        <span>POS</span>
      </button>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body *ngIf="menu === 'a4'">
    <ngx-layout-receipt-a4
      *ngIf="!shop.code || shop.code === '' || isDefault"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [user]="user"
      [receipt]="receipt"
      [showDept]="showDept"
    >
    </ngx-layout-receipt-a4>

    <ngx-layout-receipt-a4-vfood
      *ngIf="shop.code === 'vfood'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [receipt]="receipt"
      [isRefLanguage]="isRefLanguage"
    >
    </ngx-layout-receipt-a4-vfood>

    <ngx-layout-receipt-a4-daian
      *ngIf="shop.code === 'daian'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [user]="user"
      [receipt]="receipt"
      [showDept]="showDept"
    >
    </ngx-layout-receipt-a4-daian>

    <ngx-layout-receipt-a4-ppd
      *ngIf="shop.code === 'ppd'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [user]="user"
      [receipt]="receipt"
      [showDept]="showDept"
      [totalAmountText]="totalAmountText"
      [totalAmountDebitText]="totalAmountDebitText"
    >
    </ngx-layout-receipt-a4-ppd>
  </nb-card-body>

  <nb-card-body *ngIf="menu === 'a4-stock'">
    <ngx-layout-receipt-a4-stock
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [user]="user"
      [receipt]="receipt"
    >
    </ngx-layout-receipt-a4-stock>
  </nb-card-body>

  <nb-card-body *ngIf="menu === 'pos'">
    <ngx-layout-receipt-pos
      *ngIf="shop.code !== 'vfood'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [receipt]="receipt"
      [isRefLanguage]="isRefLanguage"
    >
    </ngx-layout-receipt-pos>
    <ngx-layout-receipt-pos-vfood
      *ngIf="shop.code === 'vfood'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [receipt]="receipt"
      [isRefLanguage]="isRefLanguage"
    >
    </ngx-layout-receipt-pos-vfood>
  </nb-card-body>

  <nb-card-footer>
    <nb-checkbox
      *ngIf="shop.code === 'vfood'"
      [(ngModel)]="isRefLanguage"
      status="danger"
    >
      Ngôn ngữ khác
    </nb-checkbox>

    <nb-checkbox [(ngModel)]="showDept" status="danger">
      Hiển thị công nợ
    </nb-checkbox>

    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
